module.exports = __webpack_public_path__ + "static/media/5-7.97802a01.mp3";